import MoreVertIcon from "@mui/icons-material/MoreVert"
import { Box, Container, Grid, IconButton, Menu, MenuItem, Typography } from "@mui/material"
import { useApiGet } from "auth/useApi2"
import Button from "components/Button"
import ClpTable from "components/ClpTable"
import { GlobalLoaderContext } from "components/GlobalLoadingProvider"
import { apiEndpoints } from "generated/apiEndpoints"
import { allRoutes } from "generated/routes"
import React, { useContext, useEffect, useMemo } from "react"
import { Link, useHistory } from "react-router-dom"
import { StyledTableContainer } from "shared/styled/Global"
import { EditCustomerNavigation } from "../../components/EditCustomerNavigation"
import { useTranslation } from "react-i18next"

const EditCustomerUsers = ({ match }) => {
  const [usersResult, getUsers] = useApiGet()
  const loadingContext = useContext(GlobalLoaderContext)
  const routerHistory = useHistory()
  const { t } = useTranslation()

  useEffect(() => {
    getUsers(apiEndpoints.systemadmincustomers.getcustomerusers.replace("{id}", match.params.id))
  }, [getUsers, match.params.id])

  useEffect(() => {
    loadingContext.setLoading(() => usersResult.status === 1)
  })

  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)

  const openSettingsDropdown = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const closeSettingsDropdown = () => {
    setAnchorEl(null)
  }

  const columns = [
    {
      accessorKey: "name",
      header: t("global.name", "Name")
    },
    {
      accessorKey: "username",
      header: t("settings.user.username", "Username")
    },
    {
      accessorKey: "email",
      header: t("global.email", "Email")
    },
    {
      accessorKey: "manager.name",
      header: t("global.manager", "Manager")
    },
    {
      accessor: (cell) => {
        return cell.disabled ? t("global.yes", "Yes") : ""
      },
      header: t("global.disabled", "Disabled")
    }
  ]

  return (
    <div>
      <EditCustomerNavigation customerId={match.params.id} />
      <Container>
        <Box>
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="h1">{t("settings.customer.administer_user", "Administer user")}</Typography>
            <Box mt={{ xs: 2, sm: 0 }}>
              <Button
                color="primary"
                component={Link}
                to={allRoutes.SystemadminCustomersEditUsersAdd(match.params.id)}>
                {t("settings.user.add_user", "Add user")}
              </Button>
              <IconButton
                aria-label="Inställningar"
                aria-controls="settings-menu"
                aria-haspopup="true"
                onClick={openSettingsDropdown}
                size="medium">
                <MoreVertIcon fontSize="medium" />
              </IconButton>
              <Menu id="settings-menu" anchorEl={anchorEl} open={open} onClose={closeSettingsDropdown}>
                <MenuItem
                  onClick={() => {
                    routerHistory.push(allRoutes.SystemadminCustomersEditUsersImport(match.params.id))
                  }}>
                  {t("settings.customer.import_user", "Import users")}
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    routerHistory.push(
                      allRoutes.SystemadminCustomersEditUsersImportlegacyexams(match.params.id)
                    )
                  }}>
                  {t("settings.customer.import_learning_results", "Import learning results")}
                </MenuItem>
              </Menu>
            </Box>
          </Grid>
        </Box>
      </Container>
      <StyledTableContainer>
        <ClpTable
          rows={usersResult.status === 2 && usersResult.data}
          loadingState={usersResult.status}
          columns={columns}
          onRowClick={(row) =>
            routerHistory.push(allRoutes.SystemadminCustomersEditUsersEdit(match.params.id, row.original.id))
          }
        />
      </StyledTableContainer>
    </div>
  )
}
export default EditCustomerUsers
